import { isCheckoutOnSubscriptionModel } from "@/apps/merchant3/helpers/cartActiveFeatures.helper";
import { isDirectToCustomerFlow } from "@/apps/merchant3/helpers/checkoutFlows";

export const getChatBotIntegrationId = (country: string | null): string => {
  country = country?.toUpperCase().trim() || 'MX';

  let envVariableToLoad = 'VUE_APP_CHATBOT_M3_SMOOCH_[]_INTEGRATION_ID';

  if (isDirectToCustomerFlow.value) {
    envVariableToLoad = envVariableToLoad.replace('M3', 'D2C');
  } else if (country === 'BR' && isCheckoutOnSubscriptionModel.value) {
    envVariableToLoad = 'VUE_APP_CHATBOT_M3_SMOOCH_BR_SUBSCRIPTION_MODEL_INTEGRATION_ID';
  }

  return process.env[envVariableToLoad.replace('[]', country)] || '';
};
